import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ConsentDetailsOverviewComponent } from 'core/components/consent/consent-details-overview/consent-details-overview.component'
import { EnumAppEndpoint, EnumManager } from 'core/models'
import { APP_PERMISSION } from 'core/models/appPermissions'
import { RouteSchemeData } from 'core/models/routeScheme'
import { AuthGuardService } from 'core/services/auth-guard.service'
import { UserRoleGuard } from 'core/services/user-role.guard'

export const routesConsentDetailsOverview: Routes = [
	{
		path:
			EnumAppEndpoint.Consent +
			'/' +
			EnumManager.Approver +
			'/:workflowId/' +
			EnumAppEndpoint.Details +
			'/:scheme/:contentId',
		component: ConsentDetailsOverviewComponent,
		data: {
			manager: EnumManager.Approver,
			roles: [APP_PERMISSION.approve],
		} as RouteSchemeData,
		canActivate: [AuthGuardService, UserRoleGuard],
	},
]

@NgModule({
	imports: [RouterModule.forRoot(routesConsentDetailsOverview)],
	exports: [RouterModule],
})
export class ConsentDetailsOverviewRoutingModule {}
